import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Casestudy.css"; // Optional: For adding styles
import Casestudyi from "../../../Assets/image/web/case study copy.webp";
import Casestudyi2 from "../../../Assets/image/web/gemini-image-2_Ultra-premium_product_hero_shot_of_a_high-precision_electronic_control_module_wi-0.webp";
import { Col, Row } from "reactstrap";
import logo from "../../../Assets/image/logo.png";
import Footer from "../footer/footer";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import RevealBlurFX from "../../../components/Effect/RevealBlurFX";
import { Link } from "react-router-dom";

const Casestudy = () => {

    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);


    return (
        <>
            <div>
                <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                    <div className="mylogo">
                        <div className="logo-container">
                            <Link to="/" className="cursor-pointer">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="bar-container">
                        <Bar1 />
                    </div>
                </div>

                <div className="casestudy">
                    <div class="grid grid-cols-12">
                        <div className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-8">
                            <div className="row1">
                                <div className="Casestudylogo">
                                    <img src={Casestudyi} alt="Casestudy" name="Casestudy" style={{ height: '100%', width: '400px' }} />
                                </div>
                                <div className="data1">
                                    <h1 className="mt-2">RMS (Remote Monitoring System) for Solar Water Pumps</h1>
                                    <h2 className="mt-2">Overview</h2>
                                    <p className="mt-2">sandip electronics  and Automation specializes in providing innovative automation and IoT solutions tailored to
                                        meet the needs of agriculture and renewable energy sectors. Our mission is to enhance efficiency and sustainability
                                        through cutting-edge technology.
                                    </p>
                                    <h2 className="mt-2">Project Profile</h2>
                                    <p className="mt-2"><b>Project Name:</b> RMS (Remote Monitoring System) for Solar Water Pumps.<br />
                                        <b>Sector:</b> Agriculture & Renewable Energy.<br />
                                        <b>Core Technology:</b> IoT, GPRS/4G Connectivity, Cloud Analytics
                                    </p>
                                    <h3 className="mt-2">
                                        Project Overview
                                    </h3>
                                    <h5 className="mt-2"><b>Objective:</b> TTo design and implement a real-time remote monitoring system for solar-powered water pumps to improve operational efficiency,
                                        reduce maintenance costs, and ensure an uninterrupted water supply for agricultural purposes.
                                    </h5>

                                    <h2 className="mt-2">The Solution: SeaIoT Smart Monitoring</h2>
                                    <p className="mt-2">We integrated a high-performance Remote Monitoring System (RMS) that serves as a 24/7 digital watchman for the solar pump.<br />
                                        <b>Key Features:<br/>
                                        </b>Real-Time Data Tracking: Monitor Voltage, Current, RPM, and Power Output instantly.<br />
                                        <b>Remote Control: </b>Start or stop the pump from any location via the SeaIoT Mobile App.
                                        <br />
                                        <b>Automated Fault Protection: </b>Instant alerts for Dry Run, Overload, or Voltage fluctuations.
                                        <br />
                                    </p>

                                    <h2 className="mt-2">Key Results & Benefits</h2>
                                    <p className="mt-2">The implementation of the RMS led to significant improvements in both cost-savings and productivity:<br/>
                                        90% Faster Response: Technical faults are identified and reported in real-time, reducing system downtime.<br/>
                                        Zero Travel Costs: Remote operation eliminates the need for physical site visits to toggle the pump.<br/>
                                        Extended Equipment Life: Proactive alerts prevent motor burnouts and mechanical wear.<br/>
                                        Sustainable Farming: Better data allows for precision irrigation, saving both water and solar energy.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4 Casestudylogo2-div">
                            <div className="Casestudylogo2">
                                <img src={Casestudyi2} alt="Casestudy" name="Casestudy" style={{ height: '100%', width: '350px', borderRadius: '35px', boxShadow: '5px 2px 1px #9d9e98' }} />
                            </div>
                        </div>
                    </div>

                </div>

                <Footer />
            </div>
        </>
    );
};

export default Casestudy;

